import { CategoriesSlider } from "./categoryList";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { useCallback, useMemo } from "react";
import smoothScroll from "../../utils/animateScroll";
import { useInputMode } from "../../utils/hooks/useInputMode";

/**
 * Sort items by priority (ascending)
 * Items without priority go to the end
 */
var sortByPriority = function (items) {
  if (!items || !Array.isArray(items)) return [];

  return [...items].sort(function (a, b) {
    var aPriority = a.priority;
    var bPriority = b.priority;

    // Both null - maintain order
    if (aPriority == null && bPriority == null) return 0;
    // Null values go to the end
    if (aPriority == null) return -1;
    if (bPriority == null) return 1;

    // Parse as integers
    var aInt = typeof aPriority === "number"
      ? aPriority
      : parseInt(aPriority, 10) || 999999;
    var bInt = typeof bPriority === "number"
      ? bPriority
      : parseInt(bPriority, 10) || 999999;

    return bInt - aInt;
  });
};

var CategoriesContent = function (props) {
  var data = props.data || {};

  var focusableResult = useFocusable({
    focusKey: "category-genre-parent",
  });
  var ref = focusableResult.ref;
  var focusKey = focusableResult.focusKey;

  var rawCategories = data.categories || [];
  var rawGenres = data.genres || [];

  // Add kind identifier to each item and sort by priority
  var categories = useMemo(function () {
    var items = rawCategories.map(function (item) {
      return Object.assign({}, item, { kind: "category" });
    });
    return sortByPriority(items);
  }, [rawCategories]);

  var genres = useMemo(function () {
    var items = rawGenres.map(function (item) {
      return Object.assign({}, item, { kind: "genre" });
    });
    return sortByPriority(items);
  }, [rawGenres]);

  var inputModeResult = useInputMode();
  var isMouseFocus = inputModeResult.isMouseFocus;
  var onRowFocus = useCallback(
    function (focusProps) {
      if (isMouseFocus) return;
      var height = focusProps.height;
      var top = focusProps.top;
      smoothScroll(ref, top < 200 ? 0 : top - height / 2, 500);
    },
    [ref, isMouseFocus]
  );

  return (
    <div className="legacy-parent-table-shell">
      <div className="legacy-parent-table-cell">
        <FocusContext.Provider value={focusKey}>
          <div className="legacy-parent-category-scroll" ref={ref}>
            <CategoriesSlider
              categories={categories}
              rowTitle="دسته بندی ها"
              onFocus={onRowFocus}
              id="main-categories"
            />
            <CategoriesSlider
              categories={genres}
              rowTitle="ژانر ها"
              onFocus={onRowFocus}
              id="main-genres"
            />
          </div>
        </FocusContext.Provider>
      </div>
    </div>
  );
};

export default CategoriesContent;
